import { HoopsGameSideDTO } from "../../dto/HoopsGameBasketDTO";

/** Which side of a matchup. A game itself stores `homeTeam`/`awayTeam` as named
 *  fields, but a basket needs its side as a value — see {@link HoopsGameSideDTO}. */
export enum HoopsGameSide {
    HOME = 'home',
    AWAY = 'away'
}

export namespace HoopsGameSide {
    export function fromDTO(side: HoopsGameSideDTO): HoopsGameSide {
        return side === 'away' ? HoopsGameSide.AWAY : HoopsGameSide.HOME;
    }
}
